/**
 * Validates date format
 * @param value Date string
 * @returns {boolean} True if value is in the format YYYY-MM-DD
 */
function isValidDateFormat(value) {
  return (/\d{4}-\d{2}-\d{2}/).test(value);
}

export default (value) => {
  if (!value || value.length === 0) {
    return true;
  }

  return isValidDateFormat(value);
};



// WEBPACK FOOTER //
// ./src/utils/validators/DateFormat.js